const e = {
  add: "Hinzufügen",
  cancel: "Abbrechen",
  clear: "Löschen",
  confirm: "Bestätigen",
  delete: "Löschen",
  redo: "Wiederherstellen",
  save: "Speichern",
  saveAs: "Speichern unter",
  undo: "Rückgängig machen"
}, n = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, t = {
  cancel: "Abbrechen",
  confirm: "Bestätigen",
  datePlaceholder: "Datum auswählen",
  datetimePlaceholder: "Datum und Uhrzeit auswählen",
  endDatePlaceholder: "Enddatum",
  endDatetimePlaceholder: "Enddatum und Endzeit",
  endMonthPlaceholder: "Letzter Monat",
  monthPlaceholder: "Monat auswählen",
  now: "Jetzt",
  quarterPlaceholder: "Quartal auswählen",
  selectDate: "Datum auswählen",
  selectTime: "Zeit auswählen",
  startDatePlaceholder: "Startdatum",
  startDatetimePlaceholder: "Startdatum und -zeit",
  startMonthPlaceholder: "Startmonat",
  today: "Heute",
  weekPlaceholder: "Woche auswählen",
  yearPlaceholder: "Jahr auswählen",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, a = {
  placeholder: "Bitte auswählen"
}, l = {
  clear: "Löschen",
  negativeText: "Abbrechen",
  now: "Jetzt",
  placeholder: "Zeit auswählen",
  positiveText: "OK"
}, r = {
  placeholder: "Bitte eingeben"
}, o = {
  placeholder: "Bitte eingeben"
}, s = {
  placeholder: "Eingeben..."
}, c = {
  allRows: "Alle Zeilen",
  default: "Standard",
  deleteLayoutDescription: "Möchten Sie dieses Layout wirklich löschen?",
  discardChanges: "Änderungen verwerfen",
  discardLayoutChanges: "Änderungen am Layout verwerfen",
  enterLayoutName: "Layout-Namen eingeben",
  enterRowNumber: "Anzahl der Zeilen eingeben",
  fieldsSelected: "Ausgewählte Felder",
  freezeColumnDescription: "Frieren Sie die linke Spalte ein",
  freezeUptoColumn: "Spalte einfrieren",
  frozen: "Eingefroren",
  layoutName: "Layout Name",
  manageColumns: "Spalten verwalten",
  none: "Nichts",
  reorderRows: "Zeilen neu anordnen",
  rowsSelected: "Zeilen ausgewählt",
  saveLayoutAs: "Layout speichern als",
  saveLayoutNew: "Neues Layout speichern",
  search: "Suchen",
  searchColumnsPlaceholder: "Spalten durchsuchen",
  searchFieldsPlaceholder: "Suchfelder",
  selectAll: "Alle auswählen",
  setTableHeight: "Tischhöhe einstellen",
  unfreeze: "Auftauen",
  unsavedChanges: "Bitte Änderungen speichern",
  unsavedChangesDescription: "Es sind eine oder mehrere nicht gespeicherte Änderungen vorhanden. Sollen sie gespeichert werden?"
}, i = {
  at: "bei",
  colorAlreadyUsed: "Bitte eine andere Farbe auswählen oder die aktuelle verwenden",
  colorNamePlaceholder: "Namen eingeben",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Bitte anderen Farbennamen auswählen",
  noColorsAdded: "Sie haben in diesem Abschnitt keine Farben."
}, d = {
  searchPlaceholder: "Suchen"
}, h = {
  invalidPastedData: "Ungültige eingefügte Daten"
}, u = {
  of: "von",
  page: "Seite",
  rowsPerPage: "Zeilen pro Seite"
}, p = {
  failedToUpload: "Upload fehlgeschlagen",
  retry: "Wiederholen",
  clickToUpload: "Klicken Sie zum Upload",
  orDragAndDrop: "Oder ziehen und ablegen",
  supportedFileTypes: "Unterstützte File :"
}, g = {
  global: e,
  Progress: n,
  DatePicker: t,
  Select: a,
  TimePicker: l,
  Input: r,
  InputNumber: o,
  InputTag: s,
  HLDataTable: c,
  ColorPicker: i,
  InputPhone: d,
  InputOtp: h,
  Pagination: u,
  Upload: p
};
export {
  i as ColorPicker,
  t as DatePicker,
  c as HLDataTable,
  r as Input,
  o as InputNumber,
  h as InputOtp,
  d as InputPhone,
  s as InputTag,
  u as Pagination,
  n as Progress,
  a as Select,
  l as TimePicker,
  p as Upload,
  g as default,
  e as global
};
